import * as React from "react";
import { getProductTealiumDescription } from "@grandvisionhq/fun-products";
import { ProductBlockGallery } from "@grandvisionhq/lib-visuals";
import { ProductListingBlock } from "../../../ProductListingBlock/lib-components/ProductListingBlock/ProductListingBlock.js";
const ProductListingGallery = ({
  products,
  isLoading,
  hasError,
  reimbursableLogos,
  productLocation,
  onProductImpression,
  onProductInteraction,
  skus,
  shouldCenterSlideItems,
  shouldSendTealiumEvent
}) => {
  const renderBlock = ({ blockKey, tabIndex, className, index }) => {
    const productIndex = products.findIndex(
      ({ masterVariant, variants }) => masterVariant.sku === blockKey || variants.some(({ sku }) => sku === blockKey)
    );
    const product = products[productIndex];
    if (!product) {
      return null;
    }
    const elementIndex = index || 0;
    const tealiumAttributes = shouldSendTealiumEvent ? {
      "data-element-id": `AlsoLike_Tile_${elementIndex + 1}`,
      "data-description": getProductTealiumDescription(product.name.en, blockKey)
    } : void 0;
    return /* @__PURE__ */ React.createElement(
      ProductListingBlock,
      {
        key: blockKey,
        listingProduct: product,
        reimbursableLogos,
        className,
        tabIndex,
        productLocation,
        onImpression: () => onProductImpression?.(product, productIndex),
        onInteraction: () => onProductInteraction?.(product, productIndex),
        selectedVariant: blockKey,
        tealiumAttributes
      }
    );
  };
  return /* @__PURE__ */ React.createElement(
    ProductBlockGallery,
    {
      isLoading,
      hasError,
      blockKeys: skus,
      renderBlock,
      shouldCenterSlideItems
    }
  );
};
export {
  ProductListingGallery
};
//# sourceMappingURL=ProductListingGallery.js.map
